(function () {
  document.querySelectorAll('[data-pair-with-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sectionId = btn.getAttribute('data-pair-with-btn');
      var variantId = btn.getAttribute('data-variant-id');
      var message = document.getElementById('pair-with-message-' + sectionId);
      var addLabel = btn.getAttribute('data-label-add') || 'Add to cart';

      btn.disabled = true;
      btn.textContent = '...';

      fetch('/cart/add.js?sections=cart-drawer,cart-icon-bubble', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          btn.disabled = false;
          btn.textContent = addLabel;

          if (data.status) {
            message.textContent = data.description || 'Error adding to cart';
            message.hidden = false;
            setTimeout(function () { message.hidden = true; }, 3000);
            return;
          }

          // Actualiza cart icon bubble
          var sections = data.sections || {};
          if (sections['cart-icon-bubble']) {
            var bubbleEl = document.getElementById('cart-icon-bubble');
            if (bubbleEl) {
              var bubbleDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
              var bubbleInner = bubbleDoc.querySelector('.shopify-section');
              if (bubbleInner) bubbleEl.innerHTML = bubbleInner.innerHTML;
            }
          }

          // Delega al CartDrawer nativo para que abra correctamente y re-registre el overlay
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          } else if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }

          // Actualiza la barra de progreso de envío con el total real del carrito
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              window.cart = cart;
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            });

          message.textContent = 'Added to cart!';
          message.hidden = false;
          setTimeout(function () { message.hidden = true; }, 3000);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = addLabel;
        });
    });
  });
})();
